module.exports = __webpack_public_path__ + "img/visa-master-card.f1694f42.svg";